import {
  Box,
  Text,
  CheckboxGroup,
  Checkbox,
  FormControl,
  FormLabel,
} from '@frontend/legacy-components';

const StatusFilter = ({
  data,
  selectedStatuses,
  onChange,
  possibleStatuses,
  statusLabels,
}) => {
  const statusAgg = data?.aggs.statusesAgg.statuses;

  if (!statusAgg) {
    return null;
  }

  return (
    <Box mb={2}>
      <FormControl>
        <FormLabel>Status</FormLabel>
        <CheckboxGroup direction="column">
          {possibleStatuses.map((status) => (
            <Checkbox
              key={status}
              isChecked={selectedStatuses.includes(status)}
              isDisabled={!statusAgg.buckets?.some(({ key }) => key == status)}
              onChange={() => onChange(status)}
            >
              <Text textTransform="capitalize" display="inline">
                {statusLabels[status]}
              </Text>
              &nbsp;(
              {statusAgg.buckets?.find(({ key }) => key === status)
                ? statusAgg.buckets?.find(({ key }) => key === status).docCount
                : 0}
              )
            </Checkbox>
          ))}
        </CheckboxGroup>
      </FormControl>
    </Box>
  );
};

export default StatusFilter;
